import React, {createRef, FC, useEffect, useMemo, useRef, useState} from "react";
import {Button, Form, FormInstance, Input, Radio, Select, SelectProps, Spin, Tooltip} from "antd";
import {sourceLanguageOptions, speakerOptions} from "../Web/Outside/pages/tools/dict";
import {CloseOutlined} from '@ant-design/icons';
import {createBrowserHistory} from 'history';
import s from './index.module.scss';
import {Recorder} from "../../utils/Recorder";
import {startRecord, stopRecord, heartTimeout} from '../../api/grt/ai';
import {LeftOutlined} from "@ant-design/icons";
import {useNavigate, useParams} from "react-router-dom";
import moment from 'moment';
import RecordImg from '../../assets/images/record-img.png';
import {cloneDeep} from "lodash";
import '../../assets/font/iconfont.css';
import Utils, {RequestResult} from "../../components/Utils";
import person4 from '@/assets/images/tw/person4.png';
import recordPause from '@/assets/images/record-pause.png';
import recordPlay from '@/assets/images/record-play.gif';
import recordLoading from '@/assets/images/record-loading.gif';
import ToastUtils from "../../utils/ToastUtils";
import Toast from "../../components/Toast";
import {fetchCheckCanRecord} from '../../api/tingWu';

type FormDataType = {
    source_language?: string;
    speaker_count?: number;
    target_languages?: string;
    task_id?: string;
    document_name?: string;
};
type RequestResultType = {
    success: boolean;
    msg?: string;
}
type AddRecordRequestResultDataType = {
    TaskId?: string;
    MeetingJoinUrl?: string;
}
type RecordItemType = {
    id?: string;
    index?: number;
    time?: number;
    result?: string;
}

enum RecordStatus {
    START,
    PAUSE,
    LOADING,
    STOP,
    STOP_LOADING
}

enum Type {
    EDIT,
    ADD
}

interface Props {
    type?: Type
}

type AddRecordRequestResultType = { data: AddRecordRequestResultDataType } & RequestResultType;
const Record: FC<Props> = ({type}) => {
    const [formData, setFormData] = useState<FormDataType>();
    const [disabled, setDisabled] = useState<boolean>(true);
    const [started, setStarted] = useState(false);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [recordObj, setRecordObj] = useState<Recorder>();
    const [recordStatus, setRecordStatus] = useState<RecordStatus>(RecordStatus.STOP);
    const [msgList, setMsgList] = useState<{ time: number, msg: string }[]>([]);
    const formRef = createRef<FormInstance>();
    const inputRef = useRef(null);
    const recordListRef = useRef<RecordItemType[]>([]);
    const [titleData, setTitleData] = useState('');
    const [selectOptions, setSelectOptions] = useState<SelectProps['options']>([]);
    const [lock, changeLock] = useState(false);
    const [wsUrl, setWsUrl] = useState<string>('');
    const timer = useRef<number | undefined | null>(null);
    const [update, changeUpdate] = useState<number | null>(null);
    const [timeout, updateTimeout] = useState<number>(0);
    const timeoutTimer = useRef<number | undefined | null>(null);
    const navigate = useNavigate();
    const params = useParams();
    const history = createBrowserHistory();
    const scrollView = () => {
        const recordList = document.querySelector('#record-list');
        if (recordList) {
            const last = recordList.lastElementChild;
            if (last) last.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
    };
    const recordStartCallback = (payload: { index: number }) => {
        try {
            console.log(payload, "recordStartCallback");
            let recordListClone = cloneDeep(recordListRef.current);
            const index = payload.index;
            if (!recordListClone.find(item => item.index === index)) {
                recordListClone.push(payload);
            }
            recordListRef.current = recordListClone;
            changeUpdate(Math.floor(Math.random() * 10000));
            scrollView();
        } catch (e) {
            console.error(e);
        }
    };
    const startHeartBeatHandle = (task_id: string) => {
        timer.current = window.setInterval(async () => {
            const handle = await heartTimeout({task_id});
            console.log(handle, 'start Heart Beat Handle Result');
        }, 5000);
    };
    const recordChangeCallback = (payload: { index: number, result: any, time: number, words: any[] }) => {
        try {
            let recordListClone = cloneDeep(recordListRef.current);
            const index = payload.index;
            if (!recordListClone.find(item => item.index === index)) {
                recordListClone.push(payload);
            } else {
                for (const ele of recordListClone) {
                    if (ele.index === index) {
                        for (const eleKey in payload) {
                            if (eleKey === 'time') continue;
                            // @ts-ignore
                            ele[eleKey] = payload[eleKey];
                        }
                    }
                }
            }
            changeUpdate(Math.floor(Math.random() * 10000));
            recordListRef.current = recordListClone;
        } catch (e) {
            console.error(e);
        }
    };
    const recordEndCallback = (payload: { index: number, result: any, time: number, begin_time: number }) => {
        try {
            let recordListClone = cloneDeep(recordListRef.current),
                flag = false;
            for (const item of recordListClone) {
                if (payload.index === item.index && !flag) {
                    item.result = payload.result;
                    item.index = Math.floor(Math.random() * 10000);
                    flag = true;
                }
            }
            changeUpdate(Math.floor(Math.random() * 10000));
            recordListRef.current = recordListClone;
        } catch (e) {
            console.error(e);
        }
    };
    const onErrorCallback = () => {
        Toast.info('服务请求发生错误');
        setTimeout(() => {
            stopRecordHandle({callbackDetail: true});
        }, 200);
    };
    const addRecordRequest = () => {
        changeLock(true);
        //@ts-ignore
        let result: Promise<AddRecordRequestResultType> = startRecord({
            ...formData,
            agent_id: params?.agentId,
            tools_id: params.toolId
        });
        result.then((res) => {
            const {success, data, msg} = res;
            if (success && data.MeetingJoinUrl) {
                const wsUrl = data.MeetingJoinUrl,
                    task_id = data.TaskId,
                    recorder = new Recorder({
                        wsUrl,
                        recordStart: recordStartCallback,
                        recordChange: recordChangeCallback,
                        recordEnd: recordEndCallback,
                        onError: onErrorCallback
                    });
                startHeartBeatHandle(task_id as string);
                recorder.startRecord();
                const cloneForm: FormDataType = cloneDeep(formData || {});
                cloneForm.task_id = task_id;
                setTimeout(() => {
                    setRecordStatus(RecordStatus.START);
                }, 100);
                setWsUrl(wsUrl);
                setFormData(cloneForm);
                setRecordObj(recorder);
                setStarted(true);
            } else ToastUtils.showAbnormalToast(msg || '服务请求发生错误');
        });
    };
    const onValuesChange = (_change: FormDataType, all: FormDataType) => {
        const newData = Object.assign({}, formData, all);
        setFormData(newData);
    };
    const startRecordHandle = async () => {
        if (disabled) return;
        //@ts-ignore
        fetchCheckCanRecord().then((res: RequestResult & { data: boolean }) => {
            if (res.success && res.data) {
                return Toast.info('已经有一个实时录音未停止，请稍等～');
            }
            setRecordStatus(RecordStatus.LOADING);
            addRecordRequest();
        });
    };
    const pauseRecord = () => {
        changeLock(false);
        setRecordStatus(RecordStatus.LOADING);
        setTimeout(() => {
            recordObj?.stopRecord();
            setRecordStatus(RecordStatus.PAUSE);
        }, 1000);
        scrollView();
    };
    const restartRecord = () => {
        changeLock(true);
        const recorder = new Recorder({
            wsUrl,
            recordStart: recordStartCallback,
            recordChange: recordChangeCallback,
            recordEnd: recordEndCallback,
            onError: onErrorCallback
        });
        recorder.startRecord();
        setRecordObj(recorder);
        setRecordStatus(RecordStatus.START);
        scrollView();
    };
    const stopRecordHandle = ({callbackDetail, callbackList}: { callbackDetail?: boolean, callbackList?: boolean }) => {
        changeLock(false);
        if (recordStatus === RecordStatus.STOP_LOADING) return;
        if (!formData?.task_id) return;
        setRecordStatus(RecordStatus.STOP_LOADING);
        recordObj?.closeMicrophone();
        if (formData?.task_id) stopRecord({task_id: formData?.task_id}).then((res) => {
            //@ts-ignore
            if (res.data && res.success) {
                clearInterval(timer.current as number);
                if (callbackDetail) {
                    setTimeout(() => {
                        navigate(`/web/o/${params?.agentId}/tools/${params?.toolId}/${res.data}`);
                    }, 1500);
                }
                if (callbackList) {
                    setTimeout(() => {
                        navigate(`/web/o/${params?.agentId}/tools/${params?.toolId}`);
                    }, 200);
                }
            }
        });
        else Toast.info('操作失败');
    };
    const updateStatus = () => {
        //@ts-ignore
        navigator.permissions.query({name: "microphone"}).then((result) => {
            let flag = false;
            if (result.state === "granted") {
                flag = true;
            } else if (result.state === "prompt") {
                flag = false;
                //@ts-ignore
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
                //@ts-ignore
                navigator.getUserMedia(
                    {audio: true},
                    async (stream: MediaStream) => {
                        const mediaRecorder = new MediaRecorder(stream);
                        mediaRecorder.stop();
                        stream.getTracks().forEach(ele => ele.stop());
                        setDisabled(false);
                    },
                    (error: any) => {
                        setDisabled(true);
                    },
                )
            } else if (result.state === "denied") {
                flag = false;
            }
            setDisabled(!flag);
            result.addEventListener("change", () => {
                if (result.state === "denied" && recordStatus === RecordStatus.START) {
                    Toast.info('您当前的浏览器不支持麦克风录音,请开启麦克风权限继续');
                    pauseRecord();
                } else if (result.state !== "denied" && recordStatus === RecordStatus.PAUSE) {
                    Toast.info('已恢复麦克风权限，继续录音');
                    restartRecord();
                }
                setDisabled(result.state === "denied");
            });
        });
    };
    const handleInputChange = (event: { target: { value: string; }; }) => {
        setTitleData(event.target.value);
        const formDataClone: FormDataType = cloneDeep(formData || {});
        formDataClone.document_name = event.target.value;
        setFormData(formDataClone);
    };
    const handleBlur = () => {
        setIsEdit(false);
    };
    const handleEditClick = () => {
        if (!started) {
            setTitleData(formData?.document_name || '');
            setIsEdit(true);
        }
    };
    const handleEdit = () => {
        changeLock(true);
        const taskId = params.taskId;
        //@ts-ignore
        let result: Promise<AddRecordRequestResultType> = startRecord({task_id: taskId});
        result.then((res) => {
            const {success, data, msg} = res;
            if (success && data.MeetingJoinUrl) {
                const wsUrl = data.MeetingJoinUrl,
                    task_id = data.TaskId,
                    recorder = new Recorder({
                        wsUrl,
                        recordStart: recordStartCallback,
                        recordChange: recordChangeCallback,
                        recordEnd: recordEndCallback,
                        onError: onErrorCallback
                    }),
                    //@ts-ignore
                    list = data.list;
                recorder.startRecord();
                const cloneForm: FormDataType = cloneDeep(formData || {});
                cloneForm.task_id = task_id;
                setFormData(cloneForm);
                setRecordObj(recorder);
                setStarted(true);
                recordListRef.current = list;
            } else ToastUtils.showAbnormalToast(msg || '服务请求发生错误');
        });
    };

    /**
     * 播放录音（测试使用）
     */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const playBackAudio = () => {
            const audio = document.querySelector('#audio');
            if (audio && recordObj?.blobEventData) {
                const blob = new Blob(recordObj?.blobEventData, {type: 'audio/wav'});
                //@ts-ignore
                audio.src = URL.createObjectURL(blob);
                setTimeout(() => {
                    //@ts-ignore
                    audio.play();
                }, 100);
            }
        };

    /**
     * 下载录音（测试使用）
     */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const downLoadData = () => {
            if (recordObj?.blobEventData) {
                let a = document.createElement('a');
                a.download = 'record.wav';
                const blob = new Blob(recordObj?.blobEventData, {type: 'audio/wav'});
                //@ts-ignore
                a.href = window.URL.createObjectURL(blob);
                a.click();
            }
        };
    const checkCanRecord = () => {
        //@ts-ignore
        fetchCheckCanRecord().then((res: RequestResult & { data: boolean }) => {
            if (res.success && res.data) {
                Toast.info('已经有一个实时录音未停止，请稍等～');
                setTimeout(() => {
                    navigate(`/web/o/${params?.agentId}/tools/${params?.toolId}`);
                }, 500);
            }
        });
    };
    const updateTimeHandle = (timeout: number) => {
        const recordStartTime = document.querySelector('.record-start-time');
        if (recordStartTime) {
            recordStartTime.innerHTML = Utils.formatTime(timeout);
        }
    };

    useEffect(() => {
        if (recordListRef.current?.length) {
            const msg_list: any[] = [],
                list = recordListRef.current;
            let index = 0,
                count = 0;
            for (const item of list) {
                if (count > 0 && count % 3 === 0) {
                    index++;
                }
                if (msg_list[index]) {
                    const oldMsg = msg_list[index].msg || '';
                    msg_list[index].msg = oldMsg + item.result;
                } else msg_list.push({msg: item.result || '', time: item.time || 0});
                count++;
            }
            setMsgList(msg_list);
            setTimeout(scrollView, 1000);
        }
    }, [update]);
    useEffect(() => {
        if (formRef) {
            const initFormData: FormDataType = Object.assign({}, formData, {
                source_language: 'cn',
                target_languages: 'no',
                speaker_count: 1,
                document_name: moment(new Date()).format('YYYY-MM-DD HH:mm') + ' 记录'
            });
            setFormData(initFormData);
            formRef.current?.setFieldsValue(initFormData);
        }
    }, [formRef.current]);
    useEffect(() => {
        if (timeout >= 24 * 60 * 60) {
            stopRecordHandle({callbackDetail: true});
            return;
        }
        updateTimeHandle(timeout);
    }, [timeout]);
    useEffect(() => {
        if (recordStatus === RecordStatus.START) {
            timeoutTimer.current = window.setInterval(() => {
                // @ts-ignore
                updateTimeout(prevState => prevState + 1);
            }, 1000);
        } else if (recordStatus === RecordStatus.PAUSE || recordStatus === RecordStatus.STOP || recordStatus !== RecordStatus.STOP_LOADING) {
            updateTimeHandle(timeout);
            clearInterval(timeoutTimer.current as number);
        }
    }, [recordStatus]);
    useEffect(() => {
        let unBlock: any;
        if (lock) {
            // 上锁
            unBlock = history.block(({location: nextLocation}: {location: any}) => {
                unBlock();
            });
        } else {
            unBlock && unBlock(); // 解锁
        }
    }, [lock]);
    useEffect(() => {
        checkCanRecord();
        if (type === Type.EDIT) {
            handleEdit();
        } else updateStatus();
        return () => {
            clearInterval(timer.current as number);
            if (recordStatus !== RecordStatus.STOP && recordStatus !== RecordStatus.STOP_LOADING) stopRecordHandle({callbackList: true});
        };
    }, []);
    useEffect(() => {
        if (!formData?.source_language) return setSelectOptions([]);
        let resultOptions: SelectProps['options'] = [];
        switch (formData?.source_language) {
            case 'en':
                resultOptions = [{label: '不翻译', value: 'no'}, {label: '中文', value: 'cn'}, {
                    label: '日语',
                    value: 'ja'
                }];
                break;
            case 'cn':
                resultOptions = [{label: '不翻译', value: 'no'}, {label: '英语', value: 'en'}, {
                    label: '日语',
                    value: 'ja'
                }];
                break;
            case 'ja':
                resultOptions = [{label: '不翻译', value: 'no'}, {label: '中文', value: 'cn'}, {
                    label: '英语',
                    value: 'en'
                }];
        }
        return setSelectOptions(resultOptions);
    }, [formData?.source_language]);
    const noPermMsg = useMemo(() => {
        return <div style={{display: 'flex', alignItems: 'center', flexDirection: 'row', gap: 6, width: 330}}>
            <span style={{
                background: 'red',
                height: 14,
                width: 14,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                margin: '2px 0 0 4px',
                justifyContent: 'center'
            }}><CloseOutlined
                style={{color: '#fff', fontSize: 10}}/></span>
            <span style={{fontSize: 16, color: '#fff'}}>麦克风权限未开启，请开启后刷新页面重试</span></div>;
    }, [disabled]);

    const startRecordEle = useMemo(() => {
        return <div className={s['addForm-rg']}>
            <img src={RecordImg} alt={'record-img'} className={s['add-form-img']}/>
            <Form onValuesChange={onValuesChange} ref={formRef} layout="vertical">
                <Form.Item name="source_language" label='录音语言'>
                    <Radio.Group
                        block
                        optionType="button"
                        buttonStyle="solid">
                        {sourceLanguageOptions.map(option => (
                            <Radio key={option.value} value={option.value}>
                                {option.label}
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
                <Form.Item name='target_languages' label='翻译' style={{display: 'none'}}>
                    <Select
                        style={{width: '100%'}}
                        disabled={formData?.source_language === 'yue' || formData?.source_language === 'fspk'}
                        options={selectOptions}/>
                </Form.Item>
                <Form.Item name='speaker_count' label='区分发言人' className={s['speakerList']}>
                    <Radio.Group
                        block
                        optionType="button"
                        buttonStyle="solid">
                        {speakerOptions.map(option => (
                            <Radio key={option.value} value={option.value}>
                                {option.label}
                            </Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>
            </Form>
            <div className={s['add-form-footer']}>
                <Tooltip rootClassName={'no-perm-tool-tip'} title={disabled ? noPermMsg : ''}>
                    <Button key="submit" loading={RecordStatus.LOADING === recordStatus} type="primary"
                            onClick={startRecordHandle} style={disabled ? {
                        marginRight: '16px',
                        width: '100%',
                        cursor: 'not-allowed'
                    } : {marginRight: '16px', width: '100%'}}>
                        开始录音
                    </Button>
                </Tooltip>
            </div>
        </div>;
    }, [started, formData, selectOptions, disabled]);
    const HeadTitle = () => {
        return <div className={s['ai-content-body-header-title']}>
            <div className={s['outlinedBtn']} onClick={callbackHandle}><LeftOutlined/></div>
            {isEdit ? (
                <Input
                    type="text"
                    value={titleData}
                    autoFocus={true}
                    onChange={handleInputChange}
                    onBlur={handleBlur}
                    ref={inputRef}
                    maxLength={50}
                    className={s['ai-input-edit']}
                    onKeyUp={(e) => {
                        if (e.key === 'Enter') {
                            e.preventDefault();
                            handleBlur();
                        }
                    }}
                />
            ) : (
                <span className={s['nameText']} onClick={handleEditClick}>{formData?.document_name}</span>
            )}
        </div>
    };
    const recordingFooter = useMemo(() => {
        return <div className={s['record-list-footer']}>
            <div className={s['record-list-footer-recording']}>
                <div className={s['record-list-footer-recording-img']}>{
                    recordStatus === RecordStatus.START ? <img width={30} src={recordPlay} alt={'record play'}/> :
                        <img width={30} src={recordPause} alt={'record pause'}/>
                }</div>
                <div className={s['record-list-footer-recording-time']}>
                    <span
                        className={s['record-list-footer-recording-title']}>{recordStatus === RecordStatus.START ? '录音中...' : recordStatus === RecordStatus.PAUSE ? '暂停中...' : recordStatus === RecordStatus.STOP ? '已停止' : ''}</span>
                    <div className={s['record-list-footer-recording-title']}>
                        <span className={'record-start-time'}>00:00</span>/<span
                        className={'record-end-time'}>24:00:00</span></div>
                </div>
            </div>
            <div className={s['record-list-footer-operate']}>
                <span className={s['record-operate-stop']}
                      style={recordStatus === RecordStatus.STOP_LOADING ? {cursor: 'not-allowed'} : {}}
                      onClick={() => stopRecordHandle({callbackDetail: true})}>
                    {
                        recordStatus === RecordStatus.STOP_LOADING ? <Spin size={'small'}
                                                                           className={s['record-operate-loading']}/> :
                            <i className={'iconfont icon-shishizhuanlu-tingzhi'}/>
                    }
                </span>
                <span className={s['record-operate-start']}
                      style={recordStatus === RecordStatus.LOADING || recordStatus === RecordStatus.STOP_LOADING ? {cursor: 'not-allowed'} : {}}
                      onClick={recordStatus === RecordStatus.PAUSE ? restartRecord : recordStatus === RecordStatus.START ? pauseRecord : () => {
                      }}>
                    {
                        recordStatus === RecordStatus.LOADING ?
                            <Spin size={'small'}
                                  className={s['record-operate-loading']}/> : recordStatus === RecordStatus.PAUSE ?
                                <i className={'iconfont icon-shishizhuanlu-bofang '}/> :
                                <i className={'iconfont icon-shishizhuanlu-zanting'}/>
                    }
                </span>
                <audio style={{display: "none"}} id={'audio'}/>
                {/*<Button disabled={!recordObj?.blobData} onClick={playBackAudio}>播放录音</Button>*/}
                {/*<Button disabled={!recordObj?.blobData} onClick={downLoadData}>下载录音</Button>*/}
            </div>
        </div>
    }, [recordStatus, formData]);
    const recordListEle = useMemo(() => {
        return <div className={s['record-list']} id={'record-list'}>
            {msgList.map((ele, index) => <div key={ele.msg}
                                              className={s['record-list-item']}>
                <div
                    className={s['record-list-item-head']}>
                    <img width={22} src={person4} alt={'发言人'}/>&emsp;
                    <span>发言人</span>&emsp;
                    {ele.time ? Utils.formatTime(ele.time / 1000) : ''}
                </div>
                <div
                    className={s['record-list-item-content'] + ' ' + (index === msgList.length - 1 ? s['active'] : '')}>
                    <span>{ele.msg || ''}</span>{index === msgList.length - 1 ?
                    <img src={recordLoading} alt={'loading'} style={{margin: '0 0 -10px 0'}} height={14}/> : null}
                </div>
            </div>)}
        </div>
    }, [msgList]);
    const callbackHandle = () => {
        changeLock(false);
        if (recordStatus !== RecordStatus.STOP && recordStatus !== RecordStatus.STOP_LOADING) return stopRecordHandle({callbackList: true});
        navigate(`/web/o/${params?.agentId}/tools/${params?.toolId}`);
    }
    return <div className={s['ai-content-body']}>
        <div className={s['ai-content-body-header']}>
            <div className={'ai-header-box'}><HeadTitle/></div>
        </div>
        {started ? <div className={s['record-content']}>
            {recordListEle}
            {recordingFooter}
        </div> : startRecordEle}
    </div>;
};
export default Record;
export const EditRecord = () => {
    return <Record type={Type.EDIT}/>;
};
